function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-apple"
}, "Apple Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.47,40.85a6.27,6.27,0,0,1,3.35-5.68,7.18,7.18,0,0,0-5.67-3c-2.38-.19-5,1.38-5.93,1.38s-3.31-1.32-5.12-1.32c-3.73.06-7.7,3-7.7,8.92a16.74,16.74,0,0,0,1,5.44c.86,2.46,4,8.49,7.18,8.39,1.69,0,2.88-1.2,5.08-1.2S43.85,55,45.73,55c3.26,0,6.06-5.53,6.87-8a6.65,6.65,0,0,1-4.13-6.16Zm-3.79-11A6.33,6.33,0,0,0,46.29,25a7.09,7.09,0,0,0-4.55,2.34A6.38,6.38,0,0,0,40,32.15,5.61,5.61,0,0,0,44.68,29.86Z"
});

var SvgIconApple = function SvgIconApple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-apple",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-apple"
  }, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconApple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-apple.1f9fc36b.svg";
export { ForwardRef as ReactComponent };